var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-information-form-locked" },
    [
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.country_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v("\n            " + _vm._s(_vm.countryName) + "\n        ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.siren_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.data.legal_france.siren) +
                "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.siret_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.data.legal_france.siret) +
                "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.company_name_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.data.legal_name) + "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.vat_number_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.data.legal_france.vat) +
                "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.legal_status_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.data.legal_france.company_type) +
                "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.share_capital_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v("\n            " + _vm._s(_vm.data.capital) + "\n        ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.naf_code_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.data.legal_france.ape_naf_code) +
                "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__("CompanyInformation.legal_information.rcs_label"),
            orientation: "horizontal"
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.data.legal_france.rcs_immatriculation) +
                "\n        "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }